/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Change_Visibility_To_ShareInputs */

const en_dialog_change_visibility_to_share = /** @type {(inputs: Dialog_Change_Visibility_To_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change visibility to share`)
};

const es_dialog_change_visibility_to_share = /** @type {(inputs: Dialog_Change_Visibility_To_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia la visibilidad para compartir`)
};

/**
* | output |
* | --- |
* | "Change visibility to share" |
*
* @param {Dialog_Change_Visibility_To_ShareInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_change_visibility_to_share = /** @type {((inputs?: Dialog_Change_Visibility_To_ShareInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Change_Visibility_To_ShareInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_change_visibility_to_share(inputs)
	return en_dialog_change_visibility_to_share(inputs)
});